module.exports = __webpack_public_path__ + "img/4-philippe-bergerac-photo-1.193cfd93.png";